import React from 'react';
import { Button, Drawer, Space } from 'antd';
import type { IOrderFromWithCargoAiScreeProps } from 'components/cargos/cargo-create-with-order/components/order-from-with-cargo-ai-screen/types';
import { OpenApiFileParser } from 'components/open-api-file-parser/open-api-file-parser';

export const OrderFromWithCargoAiScreen: React.FC<IOrderFromWithCargoAiScreeProps> = ({ isOpen, onClose, onFinis }) => {
  const handleManualButtonClick = () => {
    onFinis(null);
  };

  return (
    <Drawer title='Ai assistant' placement='right' open={isOpen} size='default' onClose={onClose}>
      <Space direction='vertical' style={{ width: '100%' }}>
        <div>
          <OpenApiFileParser onFinish={onFinis} />
        </div>

        <Button type='primary' onClick={handleManualButtonClick}>
          Сontinue manually
        </Button>
      </Space>
    </Drawer>
  );
};
